import { render, staticRenderFns } from "./Resumo.vue?vue&type=template&id=2fd1f792&scoped=true"
import script from "./Resumo.vue?vue&type=script&lang=ts"
export * from "./Resumo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd1f792",
  null
  
)

export default component.exports